export default __webpack_public_path__ + "static/media/blank_token.18707294.svg";